import SelectWeex from "../elements/SelectWeex";
import {sexes} from '../ToDos.js'
import {useEffect} from "react";
import {setError} from "../api/api.js"

export default function PersonCreateView({user, handleChange, createEgo, handleExit, contracts, setUser, contractType, setContractType, sex, setSex}) {

    useEffect(() => {
        setError(null)
    }, [user]);

    return (
        <div className={"grid gridtwo-flex"} style={{width: "50%", rowGap: "4%"}}>
            <label> Vorname: </label>
            <input type="text" name="firstname" onChange={handleChange} value={user.firstname} placeholder={"Vorname"}/>
            <label> Nachname: </label>
            <input type="text" name="lastname" onChange={handleChange} value={user.lastname} placeholder={"Nachname"}/>
            <label> E-Mail: </label>
            <input type="email" name="email" onChange={handleChange} value={user.email} placeholder={"max.mustermann@test.at"}/>
            <label> Foto: </label>
            <input type="file" name="photo" accept="image/*" onChange={handleChange}/>
            <label> Telefonnummer: </label>
            <input type="tel" name="phone" onChange={handleChange} value={user.phone??""} placeholder={"Telefonnummer"}/>
            <label> Geburtstag: </label>
            <input type="date" name="birthday" onChange={handleChange} value={user.birthday} placeholder={"YYYY-MM-DD"}/>
            <label> Geschlecht: </label>
            <SelectWeex options={sexes}
                        onChange={setSex}
                        placeholder={"M/W/D"}
                        isMulti={false}
                        value={sex}
                        isClearable={false}
                        style={{width: 110}}
            />
            <label> Vertrag: </label>
            <SelectWeex options={contracts}
                        onChange={(e)=> {
                            handleChange({target: {name: "ticketsMax", value: e.tickets}})
                            setContractType(e);
                        }}
                        placeholder={"3 pro Woche"}
                        isMulti={false}
                        value={contractType}
                        style={{width: 210}}
            />
            <label> Vertragsbeginn: </label>
            <input type="date" name="contractStart"
                onChange={e=>setUser(old => {
                        return {...user,
                            "contract": {repeat: old.contract.repeat, startDate: e.target.value, endDate: old.contract.endDate}
                        }
                    })}
                value={user.contract.startDate} placeholder={"YYYY-MM-DD"}/>
            <label> Vertragsende: </label>
            <input type="date" name="contractEnd"
                onChange={e=>setUser(old => {
                        return {...user, "contract":
                            {repeat: old.contract.repeat, startDate: old.contract.startDate, endDate: e.target.value}
                        }
                    })}
                value={user.contract.endDate} placeholder={"YYYY-MM-DD"}/>
            {/*<label> Maximale Tickets: </label>*/}
            {/*<label> {user?.ticketsMax} </label>*/}
            {/*<label> Tickets: </label>*/}
            {/*<input type="number" name="tickets" onChange={handleChange} value={user.tickets} placeholder={"0"}/>*/}
            {/*<label> Kurse: </label>*/}
            {/*<input type="text" name="courses" onChange={handleChange} value={user.courses} placeholder={"0"}/>*/}
            <div style={{gridColumn: "span 2"}}>
                <span className={"error-message"} id={"error-message"}></span>
                <div style={{display:"flex", flexDirection: "row"}}>
                    <button className={"primarybutton"} onClick={createEgo} style={{width:"auto", marginRight: "2%"}}>
                        Speichern
                    </button>
                    <button className={"secondarybutton"} onClick={handleExit}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    );
}
